export const en = {
  translation: {
    general: {
      now: 'Now',
    },
    navLeft: {
      home: 'Home',
      news: 'News',
      projects: 'Projects',
      gallery: 'Gallery',
      aboutme: 'About me',
      contact: 'Contact',
      impressum: 'Imprint',
      readme: 'README'
    },
    tapbar: {
      closeAll: 'Close All'
    },
    home: {
      title: 'DWAIN',
      subTitle: 'professional /../ efficient /../ safe',
      counter: {
        experience: {
          count: '15+',
          title: 'Years of IT experience'
        },
        codeExperience: {
          count: '6000+',
          title: 'Hours of programming experience'
        },
        projects: {
          count: '10+',
          title: 'Successful projects'
        }
      }
    },
    contact: {
      title: 'Get',
      title1: 'in',
      title2: 'contact!',
      subtitle: 'I look forward to starting a project with you or being able to help you with your problems',
      form: {
        inputNameplaceholder: 'Enter your Name',
        inputMailplaceholder: 'Enter valid Email',
        inputTextplaceholder: 'Enter your message',
        enterButton: 'Send',
        sending: 'Sending...',
        errorName: 'Please enter your name',
        errorMail: 'Please enter a valid email address',
        errorText: 'Please enter a message',
        successMessage: 'Message sent successfully! I will get back to you soon.',
        errorMessage: 'An error occurred while sending. Please try again.'
      }
    },
    me: {
      infoText1: "I've been a computer nerd since I was 14. It all started old school: building my own PC, crafting my first HTML page – IT has had me hooked ever since.",
      infoText2: "Whether its IT security or nasty bugs in code, Im simply fascinated by getting to the bottom of things. Im the type of person who sticks with a problem until I find the solution. Im also a big fan of Bitcoin now, because the technology and concept behind it represent the future of trust.",
      infoText3: "But I don't just live digitally, I'm also a passionate hardware tinkerer. Planning and building PCs myself is just part of who I am. It's gotten to the point where I design and 3D print missing parts or brackets myself.",
      infoText4: "When there's time left, I work on 3D design or play some games to clear my head. This mix of technical tinkering, hardware building, and creativity is exactly my thing – and the reason why I enjoy my job as a software developer every single day.",
      infoText5: "",
      card: {
        '2026': {
          position: 'Founder & Developer',
          text: 'First Android app — full-stack app for documenting and managing plant grows'
        },
        '2018': {
          position: 'Developer',
          text: 'Development & planning of various tools'
        },
        '2016': {
          position: 'Founder',
          text: 'News page about sandbox games'
        },
        '2013': {
          position: 'Founder',
          text: 'Community Fanpage about the MMORPG Blackdesert'
        },
        '2011': {
          position: 'Founder',
          text: 'Community Fanpage about the MMORPG ArcheAge'
        }
      }
    },
    error: {
      title: 'PAGE NOT FOUND'
    },
    gallery: {
      title: 'Gallery',
      timespan: '2004 - Present',
      subtitle: 'Various pictures and videos of my work',
      empty: 'No entries yet. Add images or videos to fill your gallery.'
    },
    projects: {
      title: 'Projects',
      subtitle: 'An overview of my projects and work',
      soccerwatch: {
        description: 'Development and planning of a comprehensive streaming platform for soccer with live broadcasts, video-on-demand and community features.'
      },
      staige: {
        description: 'Modern e-sports streaming platform with real-time chat, tournament management and analysis features for professional gamers.'
      },
      sandboxer: {
        description: 'News portal about sandbox games with current articles, reviews and community discussions. The largest sandbox database with comprehensive information about sandbox games.'
      },
      blackdesert: {
        description: 'Community fan site for the MMORPG Black Desert Online with guides, news and active community.'
      },
      archeage: {
        description: 'The largest German fan page for ArcheAge with over 14 million unique clicks. Up to 10,000 simultaneous users online during peak times. Comprehensive community forum, guides, databases and current news coverage.'
      },
      mygrowbook: {
        description: 'My first Android app — full-stack application for documenting and managing plant grows with diary, cost tracking, equipment management and community features.'
      }
    },
    impressum: {
      title: 'Imprint',
      contact: {
        title: 'Contact'
      },
      disclaimer: {
        title: 'Disclaimer',
        content: 'The contents of this website have been created with the greatest care. However, I cannot guarantee the accuracy, completeness and timeliness of the content. As a service provider, I am responsible for my own content on these pages in accordance with § 7 para.1 TMG under general law.'
      },
      copyright: {
        title: 'Copyright',
        content: 'The content and works created by the site operator on these pages are subject to German copyright law. Duplication, processing, distribution and any kind of exploitation outside the limits of copyright law require the written consent of the respective author or creator.'
      }
    },
    'Welcome to React': 'Welcome to React and react-i18next'
  }
}